import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { InformationTitleComponent } from '../../../../../../../components/ecosystems/information-title/information-title.component';
import {
  IonButton,
  IonContent,
  IonInput,
  ModalController,
} from '@ionic/angular/standalone';
import { LabelDescriptionComponent } from '../../../../../../../components/ecosystems/label-description/label-description.component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';

@Component({
  selector: 'app-p00062-installation-identification-pac-poly',
  templateUrl: './p00062-installation-identification-pac-poly.component.html',
  styleUrls: ['./p00062-installation-identification-pac-poly.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    InformationTitleComponent,
    IonButton,
    IonContent,
    IonInput,
    LabelDescriptionComponent,
    ReactiveFormsModule,
    TranslatePipe,
  ],
})
export class P00062InstallationIdentificationPacPolyComponent
  implements OnInit
{
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private modalController: ModalController = inject(ModalController);
  private fb = inject(FormBuilder);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  private defaultData: any = null;
  public currentForm: FormGroup | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );

    this.initForm();
  }

  private initForm() {
    this.defaultData = JSON.stringify({
      ppIdentificationPACPoly:
        this.poolAdditionalData?.ppIdentificationPACPoly ?? '',
    });

    this.currentForm = this.fb.group({
      ppIdentificationPACPoly: [
        this.poolAdditionalData?.ppIdentificationPACPoly ?? '',
      ],
    });
  }

  onSubmit() {
    var data = {
      ppIdentificationPACPoly:
        this.currentForm!.controls['ppIdentificationPACPoly']?.value,
    };

    if (JSON.stringify(data) !== this.defaultData) {
      if (
        data.ppIdentificationPACPoly &&
        data.ppIdentificationPACPoly.startsWith(
          'https://heatpump.pool.mytech-connect.io/',
        )
      ) {
        this.poolAdditionalData!.ppIdentificationPACPoly =
          data.ppIdentificationPACPoly.replace(
            'https://heatpump.pool.mytech-connect.io/',
            '',
          );
      } else {
        this.poolAdditionalData!.ppIdentificationPACPoly =
          data.ppIdentificationPACPoly;
      }
    }

    this.next(this.actionStack!, this.poolAdditionalData!);
  }
}
